import { createContext } from "react";

const ReportEachSectionContext = createContext({
  sectionId: "",
  examReport: {},
  eyeReport: {},
  durationStartTime: "",
  duration: "",
  comments: [],
});

export { ReportEachSectionContext };
